// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isTuesday as fn } from "../isTuesday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isTuesdayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default isTuesdayWithOptions;
